module.exports = __webpack_public_path__ + "static/img/PVC_Img4.cb65b610.jpg";